import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Button } from "../components/Button";
import { useAuth } from "./AuthContext";

/** Layout route: renders the child routes only for a verified admin. */
export function RequireAdmin() {
  const { status, retry } = useAuth();
  const location = useLocation();

  if (status === "checking") {
    return (
      <div className="center-screen" role="status">
        Memuat…
      </div>
    );
  }
  if (status === "unavailable") {
    return (
      <div className="center-screen" role="alert">
        <p>Tidak dapat terhubung ke server. Sesi Anda tetap tersimpan.</p>
        <Button onClick={() => void retry()}>Coba lagi</Button>
      </div>
    );
  }
  if (status === "anonymous") {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }
  return <Outlet />;
}
